<app-page>
  <app-breadcrumb-nav></app-breadcrumb-nav>
  <app-header>
    <h1 app-overline>Production line</h1>

    <!-- 
    We add a non-breaking space while we wait for the title value to resolve (while we load the production line)
    
    This prevents page layout from jumping once we receive the production line data. Without it the
    title element would have no height when empty, and then suddently get height when a title was available, pushing
    the card element down, creating a layout jump.
    -->
    <h2 app-title>{{ (pageTitle$ | async) || '&nbsp;' }}</h2>
  </app-header>

  <app-production-line-card
    [mode]="cardMode$ | async"
    [productionLine]="productionLine$ | async"
    (edit)="onEdit()"
    (save)="onSave($event)"
    (cancel)="navigateBack()"
  ></app-production-line-card>
</app-page>
